import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "padlock",
  "use": "padlock-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"padlock\"><path d=\"M13 7.5v-2c0-2.21-1.79-4-4-4s-4 1.79-4 4v2H3.5V11c0 3.03 2.47 5.5 5.5 5.5s5.5-2.47 5.5-5.5V7.5zm-6.5-2a2.5 2.5 0 0 1 5 0v2h-5zM13 11c0 2.21-1.79 4-4 4s-4-1.79-4-4V9h8zm-4.75 1.75c0 .41.34.75.75.75s.75-.34.75-.75v-.95A1.097 1.097 0 0 0 9 9.9a1.097 1.097 0 0 0-.75 1.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol